import { __assign } from "tslib";
// DS: I10
// from GDrive
import React from 'react';
import IconWrap from '../../IconWrap';
var Comment = function (props) {
    return (React.createElement(IconWrap, __assign({}, props),
        React.createElement("svg", { width: "0", height: "0", viewBox: "0 0 24 24", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" },
            React.createElement("path", { fillRule: "evenodd", d: "M20 3H6.414a1 1 0 00-.707.293L3.293 5.707A1 1 0 003 6.414V16a1 1 0 001 1h3v3a1 1 0 001 1h1.5a1 1 0 00.8-.4L13 17h4.586a1 1 0 00.707-.293l2.414-2.414a1 1 0 00.293-.707V4a1 1 0 00-1-1z" }))));
};
Comment.displayName = 'Comment';
export default Comment;
//# sourceMappingURL=Comment.js.map